// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-EntityFiltersPage-EntityList-EntityImportButton-EntityImportButton-module__form--HhUHn .ant-upload.ant-upload-select {
  display: block !important;
}
.src-pages-EntityFiltersPage-EntityList-EntityImportButton-EntityImportButton-module__importButton--R0Rav {
  color: #ffffff;
  background-color: #595959;
}
.src-pages-EntityFiltersPage-EntityList-EntityImportButton-EntityImportButton-module__textInfo--tjzho {
  font-size: 12px;
  line-height: 1.5;
  color: #0000008c;
}
.src-pages-EntityFiltersPage-EntityList-EntityImportButton-EntityImportButton-module__textTip--JjKtz {
  display: block;
  padding: 8px 0 12px 0;
  line-height: 1.6;
  color: #000000d9;
}
.src-pages-EntityFiltersPage-EntityList-EntityImportButton-EntityImportButton-module__textError--ZhCoM {
  color: #c20034;
}
.src-pages-EntityFiltersPage-EntityList-EntityImportButton-EntityImportButton-module__uploader--Zp5rs {
  display: flex;
  flex-direction: column-reverse;
  gap: 8px;
}
.src-pages-EntityFiltersPage-EntityList-EntityImportButton-EntityImportButton-module__uploader--Zp5rs .ant-upload-list-item-container .ant-upload-list-item {
  margin-top: 0;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  height: 32px;
}
.src-pages-EntityFiltersPage-EntityList-EntityImportButton-EntityImportButton-module__uploader--Zp5rs .ant-upload-list {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.src-pages-EntityFiltersPage-EntityList-EntityImportButton-EntityImportButton-module__uploader--Zp5rs .ant-upload-list::before,
.src-pages-EntityFiltersPage-EntityList-EntityImportButton-EntityImportButton-module__uploader--Zp5rs .ant-upload-list::after {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/EntityFiltersPage/EntityList/EntityImportButton/EntityImportButton.module.less"],"names":[],"mappings":"AAAA;EAEI,yBAAA;AAAJ;AAIA;EACE,cAAA;EACA,yBAAA;AAFF;AAKA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAHF;AAMA;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AAJF;AAOA;EACE,cAAA;AALF;AAQA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;AANF;AAGA;EAMI,aAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AANJ;AAJA;EAcI,aAAA;EACA,sBAAA;EACA,YAAA;AAPJ;AATA;;EAqBI,aAAA;AARJ","sourcesContent":[".form {\n  :global(.ant-upload.ant-upload-select) {\n    display: block !important;\n  }\n}\n\n.importButton {\n  color: #ffffff;\n  background-color: #595959;\n}\n\n.textInfo {\n  font-size: 12px;\n  line-height: 1.5;\n  color: #0000008c;\n}\n\n.textTip {\n  display: block;\n  padding: 8px 0 12px 0;\n  line-height: 1.6;\n  color: #000000d9;\n}\n\n.textError {\n  color: #c20034;\n}\n\n.uploader {\n  display: flex;\n  flex-direction: column-reverse;\n  gap: 8px;\n\n  :global(.ant-upload-list-item-container .ant-upload-list-item) {\n    margin-top: 0;\n    padding: 8px;\n    border: 1px solid #d9d9d9;\n    border-radius: 4px;\n    height: 32px;\n  }\n\n  :global(.ant-upload-list) {\n    display: flex;\n    flex-direction: column;\n    row-gap: 8px;\n  }\n\n  :global(.ant-upload-list)::before,\n  :global(.ant-upload-list)::after {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `src-pages-EntityFiltersPage-EntityList-EntityImportButton-EntityImportButton-module__form--HhUHn`,
	"importButton": `src-pages-EntityFiltersPage-EntityList-EntityImportButton-EntityImportButton-module__importButton--R0Rav`,
	"textInfo": `src-pages-EntityFiltersPage-EntityList-EntityImportButton-EntityImportButton-module__textInfo--tjzho`,
	"textTip": `src-pages-EntityFiltersPage-EntityList-EntityImportButton-EntityImportButton-module__textTip--JjKtz`,
	"textError": `src-pages-EntityFiltersPage-EntityList-EntityImportButton-EntityImportButton-module__textError--ZhCoM`,
	"uploader": `src-pages-EntityFiltersPage-EntityList-EntityImportButton-EntityImportButton-module__uploader--Zp5rs`
};
export default ___CSS_LOADER_EXPORT___;
